import React from 'react';
import borderImage from '../../assets/images/businessDetails-border.png';

const BusinessDecorativeBorder: React.FC = () => {
  
  return (
    <div className="relative left-0 right-0 flex justify-center">
      <img 
        src={borderImage}
        alt="business decorative border"
        className="md:w-auto h-auto" 
      />
    </div>
  );
};

export default BusinessDecorativeBorder;